var _linearGradient, _linearGradient2, _path, _path2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _linearGradient8, _path9, _path10, _linearGradient9, _path11, _linearGradient10, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72",
    gradientUnits: "userSpaceOnUse",
    x1: -1591.758,
    y1: -1210.179,
    x2: -1590.758,
    y2: -1210.179
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72",
    gradientUnits: "userSpaceOnUse",
    x1: 71.107,
    y1: 136.139,
    x2: 143.666,
    y2: 136.139
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M72.357 136.139h70.059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M142.416 129.934V32.869H60.55l.057 102.73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M142.416 129.933H66.818c-3.416 0-6.211 2.795-6.211 6.211 0 3.416 2.795 6.211 6.211 6.211h75.598v-12.422z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72",
    gradientUnits: "userSpaceOnUse",
    x1: 66.349,
    y1: 44.674,
    x2: 54.751,
    y2: 44.674
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M56.001 44.674h9.098"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72",
    gradientUnits: "userSpaceOnUse",
    x1: 66.349,
    y1: 59.208,
    x2: 54.751,
    y2: 59.208
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M56.001 59.208h9.098"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72",
    gradientUnits: "userSpaceOnUse",
    x1: 66.349,
    y1: 73.742,
    x2: 54.751,
    y2: 73.742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M56.001 73.742h9.098"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72",
    gradientUnits: "userSpaceOnUse",
    x1: 66.349,
    y1: 88.276,
    x2: 54.751,
    y2: 88.276
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M56.001 88.276h9.098"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72",
    gradientUnits: "userSpaceOnUse",
    x1: 66.349,
    y1: 102.81,
    x2: 54.751,
    y2: 102.81
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M56.001 102.81h9.098"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72",
    gradientUnits: "userSpaceOnUse",
    x1: 66.349,
    y1: 117.344,
    x2: 54.751,
    y2: 117.344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M56.001 117.344h9.098"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M81.162 46.613h44.579v12.976H81.162z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72",
    gradientUnits: "userSpaceOnUse",
    x1: 84.918,
    y1: 99.138,
    x2: 121.65,
    y2: 99.138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.293 84.371h3.188c.839 0 1.636.311 2.266.864 2.157 1.913 7.251 6.882 9.953 13.235 1.947 4.582 1.678 8.417 1.695 8.678.05.923-.562 5.321-5.715 6.059-3.097.445-7.528.671-11.405.697h.018c-3.877-.025-8.308-.252-11.405-.697-5.153-.739-5.766-5.136-5.715-6.059.017-.26-.252-4.095 1.695-8.678 2.702-6.353 7.796-11.321 9.953-13.235a3.42 3.42 0 012.266-.864h3.206z",
    fill: "none",
    stroke: "url(#SVGID_8_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72",
    gradientUnits: "userSpaceOnUse",
    x1: 93.182,
    y1: 79.216,
    x2: 113.372,
    y2: 79.216
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.291 84.446h7.656c.408 0 .782-.224.976-.582l4.065-7.526a1.11 1.11 0 00-.142-1.262c-.613-.697-1.882-1.579-4.058-.765-3.303 1.236-3.011 2.315-7.101.629-2.854-1.176-4.898.044-5.873.889a1.108 1.108 0 00-.239 1.383l3.749 6.668c.197.35.566.566.967.566z",
    fill: "none",
    stroke: "url(#SVGID_9_fb25549e422789ba733f11c7f6dbe257074c4499b09da25a8eb02a2e4ed6ee72)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M106.428 96.912s-.556-3.215-3.215-3.215-3.373 3.215-3.373 3.215l6.906 5.236"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M100.158 102.148s.556 3.215 3.215 3.215 3.373-3.215 3.373-3.215M103.293 90.959v2.739M103.293 105.363v2.738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentJournal);
export default __webpack_public_path__ + "static/media/paymentJournal.efe8171dde17ccf907c9e319190815c0.svg";
export { ForwardRef as ReactComponent };